import React from 'react';
import { EyeOff } from 'lucide-react';

/**
 * BlurScopeContent
 * - Borras o conteúdo (children) e exibe uma camada central com mensagem/ícone
 * - Se nenhum children for passado, renderiza um "skeleton" para simular conteúdo por trás
 */
const SkeletonBackdrop = () => (
  <div className="w-full h-full flex items-center justify-center">
    <div className="grid grid-cols-12 gap-2 w-full h-4/5 items-end px-2">
      {Array.from({ length: 12 }).map((_, i) => (
        <div key={i} className="bg-blueLight/40 rounded" style={{ height: `${20 + (i % 6) * 12}%` }} />
      ))}
    </div>
  </div>
);

const BlurScopeContent = ({
  icon: Icon = EyeOff,
  title = 'Visualização indisponível',
  subtitle,
  children,
  className = '',
  blurPx = 12,
}) => {
  return (
    <div className={`relative w-full h-full ${className}`}>
      {/* camada “por trás” que será borrada */}
      <div
        className="w-full h-full rounded-custom20 overflow-hidden"
        style={{
          filter: `blur(${blurPx}px)`,
          transform: 'translateZ(0)', // ajuda em alguns browsers
          opacity: 0.85,
          pointerEvents: 'none',
          userSelect: 'none',
        }}
        aria-hidden="true"
      >
        {children ?? <SkeletonBackdrop />}
      </div>

      {/* overlay central (cartão fosco) */}
      <div className="absolute inset-0 flex items-center justify-center p-6">
        <div
          className="rounded-2xl shadow-lg text-center px-6 py-5"
          style={{
            background: 'rgba(255,255,255,0.6)',
            border: '1px solid rgba(20,49,69,0.12)',
            backdropFilter: 'blur(8px)',
          }}
          role="status"
          aria-live="polite"
        >
          <div className="mx-auto mb-3 flex items-center justify-center">
            <Icon className="text-blueDarker" size={24} strokeWidth={1.75} />
          </div>
          <div className="text-blueDarker font-semibold">{title}</div>
          {subtitle && <div className="text-blueDarker text-sm mt-1">{subtitle}</div>}
        </div>
      </div>
    </div>
  );
};

export default BlurScopeContent;
